export default __webpack_public_path__ + "media/images/features/local_delivery/episode6/LP_02-7c223e312216ae9a21c2e08699cb2981.jpeg";